import { cosmetic } from '../../shared/cosmetics.ts';
import { usePreferences } from './preferences.ts';

/** Returns a lookup for an item's name in the current language. */
export function useCosmeticName(): (id: string | null | undefined) => string {
  const { prefs } = usePreferences();
  return (id) => {
    const item = cosmetic(id);
    return item ? item.name[prefs.locale] : '';
  };
}
